<div style="margin-top: 160px">
  <app-loading-component></app-loading-component>
</div>
